<template>
    <div class="ask-modal" v-if="visible">
        <div class="ask-modal-mask" @click="handleCancel(false)" />
        <div class="ask-modal-content">
            <div class="ask-modal-header">
                <div class="title">{{ title }}</div>
                <span class="close" @click="handleCancel(false)"></span>
            </div>
            <div class="ask-modal-body">
                <div>{{ content }}</div>
            </div>
            <div class="ask-modal-footer">
                <div class="btn" @click="handleCancel(true)">{{ cancelText }}</div>
                <div class="btn confirm-btn" @click="handleConfirm">
                    {{ confirmText }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { stopBodyScroll } from '@/util/dom';

export default {
    name: 'ask-modal',
    componentName: 'askModal',
    props: {
        visible: {
            type: Boolean,
            value: false
        },
        title: {
            type: String,
            value: '预约试驾'
        },
        content: String,
        cancelText: {
            type: String,
            value: '否'
        },
        confirmText: {
            type: String,
            value: '是'
        }
    },
    methods: {
        handleCancel(flag) {
            this.$emit('cancel', flag);
        },
        handleConfirm() {
            this.$emit('confirm');
        }
    },
    watch: {
        visible(n) {
            stopBodyScroll(n);
        }
    }
};
</script>

<style lang="less" scoped>
@import '~src/assets/css/mixin.less';
@import '~src/assets/css/variable.less';
.ask-modal {
    display: block;
    position: fixed;
    z-index: 1001;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.4);
    width: 100%;
    height: 100%;
    animation: 0.3s fadeIn;
}
.ask-modal-mask {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
}
.ask-modal-content {
    background: #fff;
    color: #363c54;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    overflow: hidden;
    box-sizing: border-box;
    padding: 0 25 * @layout375;
}
.ask-modal-header {
    position: relative;
    padding: 20 * @layout375 0;
}
.ask-modal-header .title {
    font-size: 20 * @layout375;
    font-weight: bold;
    line-height: 20 * @layout375;
}
.ask-modal-header .close {
    position: absolute;
    right: 0;
    top: 20 * @layout375;
    width: 20 * @layout375;
    height: 20 * @layout375;
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwBAMAAAClLOS0AAAAG1BMVEVHcExpbn9ibHpqbYBqbX5mZoBpbYBobH5pbX8ZklvmAAAACHRSTlMAnBbUWQq8fwUtPhEAAACnSURBVDjL5dNNCsMgEAVghfxsC9m4zBl6iJBlyRVCDtAjFDdz7BqR8Y2+E7SuHOWDmSc69xfrjcX20u0sj3o+yKV7L596scuzFqGSQeLqGDEAiAVAGqCkBUo6UEgPCiEgEwYyoeAmFNyEg9QShuwwVgwZQQyUpJY8I3kGRvIMhJShe1KG7oim1BJNqSEQqyUQqyHmHZBMGKuHYjzxHRYoDuzk+KmP/AVZBzZ2i29QLQAAAABJRU5ErkJggg==);
    background-repeat: no-repeat;
    background-size: cover;
}
.ask-modal-body {
    font-size: 16 * @layout375;
    padding: 12 * @layout375 0;
}
.ask-modal-footer {
    padding: 15 * @layout375 0;
    display: flex;
}
.ask-modal-footer .btn {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 44 * @layout375;
    line-height: 44 * @layout375;
    flex: 1;
    margin-left: 10 * @layout375;
    border: 1@layout375 solid #f0f1f2;
    border-radius: 22 * @layout375;
    color: #696d7f;
    font-size: 16 * @layout375;
}
.ask-modal-footer .btn:first-child {
    margin-left: 0;
}
.ask-modal-footer .btn.confirm-btn {
    background: #00b5b6;
    border-color: #00b5b6;
    color: #fff;
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}
</style>




// WEBPACK FOOTER //
// src/views/marketing/components/asking-modal.vue